const actions = {
  nextStep({ commit }) {
    commit('nextStep');
  },
  prevStep({ commit }) {
    commit('prevStep');
  },
  setStep({ commit }, stepNumber) {
    commit('setStep', stepNumber);
  },
  setSessionSettings({ commit }, sessionSettings) {
    commit('setSessionSettings', sessionSettings);
  },
};

export default actions;
